module.exports = __webpack_public_path__ + "static/media/2122-service-2-8-min.19523219.jpg";